import { Mark } from '@tiptap/core'
import type { Node as ProseMirrorNode } from '@tiptap/pm/model'
import type { EditorState, Transaction } from '@tiptap/pm/state'
import { Plugin } from '@tiptap/pm/state'

// const CURRENT_VALUE_TEXT = '{currentValue}'
const CURRENT_VALUE_PATTERN = /\{\s*currentValue\s*\}/g

export const CurrentValueMark = Mark.create({
    name: 'currentValue',
    inclusive: false,
    parseHTML() {
        return [{ tag: 'span[data-current-value]' }]
    },
    renderHTML({ HTMLAttributes }) {
        return ['span', { ...HTMLAttributes, 'data-current-value': 'true', class: 'current-value' }, 0]
    },
    addProseMirrorPlugins() {
        return [
            new Plugin({
                appendTransaction: (transactions: readonly Transaction[], _oldState: EditorState, newState: EditorState) => {
                    if (!transactions.some(tr => tr.docChanged)) return
                    if (transactions.some(tr => tr.getMeta('currentValueMark'))) return
                    const markType = this.type
                    let tr = newState.tr
                    let modified = false
                    newState.doc.descendants((node: ProseMirrorNode, pos: number) => {
                        if (!node.isText) return
                        const text = node.text ?? ''
                        if (!text.length) return
                        const from = pos
                        const to = pos + text.length
                        if (tr.doc.rangeHasMark(from, to, markType)) {
                            tr = tr.removeMark(from, to, markType)
                            modified = true
                        }
                        CURRENT_VALUE_PATTERN.lastIndex = 0
                        let match: RegExpExecArray | null
                        while ((match = CURRENT_VALUE_PATTERN.exec(text))) {
                            const start = pos + match.index
                            const end = start + match[0].length
                            if (!tr.doc.rangeHasMark(start, end, markType)) {
                                tr = tr.addMark(start, end, markType.create())
                                modified = true
                            }
                        }
                    })

                    if (!modified) return
                    tr.setMeta('currentValueMark', true)
                    return tr
                }
            })
        ]
    }
})
